export const getDirectusImageUrl = (imageId) => `${process.env.NEXT_PUBLIC_DIRECTUS_URL}assets/${imageId}`;
